// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"be533a5b","703":"57905994","787":"a41babc4"}[chunkId] + ".chunk.js";
};